import { SvgIcon } from "@mui/material";
import React from "react";

export default function MenuCalendarIcon({ ...props }) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M20 6.40723C20 5.85494 19.5523 5.40723 19 5.40723H5C4.44772 5.40723 4 5.85494 4 6.40723V20.4072C4 20.9595 4.44772 21.4072 5 21.4072H19C19.5523 21.4072 20 20.9595 20 20.4072V6.40723ZM22 20.4072C22 22.0641 20.6569 23.4072 19 23.4072H5C3.34315 23.4072 2 22.0641 2 20.4072V6.40723C2 4.75037 3.34315 3.40723 5 3.40723H19C20.6569 3.40723 22 4.75037 22 6.40723V20.4072Z" />
        <path d="M15 6.40723V2.40723C15 1.85494 15.4477 1.40723 16 1.40723C16.5523 1.40723 17 1.85494 17 2.40723V6.40723C17 6.95951 16.5523 7.40723 16 7.40723C15.4477 7.40723 15 6.95951 15 6.40723Z" />
        <path d="M7 6.40723V2.40723C7 1.85494 7.44772 1.40723 8 1.40723C8.55228 1.40723 9 1.85494 9 2.40723V6.40723C9 6.95951 8.55228 7.40723 8 7.40723C7.44772 7.40723 7 6.95951 7 6.40723Z" />
        <path d="M21 9.40723C21.5523 9.40723 22 9.85494 22 10.4072C22 10.9595 21.5523 11.4072 21 11.4072H3C2.44772 11.4072 2 10.9595 2 10.4072C2 9.85494 2.44772 9.40723 3 9.40723H21Z" />
      </svg>
    </SvgIcon>
  );
}
